var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZendeskMark = function SvgZendeskMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "24px",
    viewBox: "0 0 33 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5cac612d0ca8b584d1e9799f_solo copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-325.000000, -6292.000000)",
    fill: "#03363D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(293.000000, 6256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5cac612d0ca8b584d1e9799f_solo-copy",
    transform: "translate(32.800000, 36.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.5099355 6.38245161 14.5099355 23.8575484 0.0356129032 23.8575484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5099355,0.109935484 C14.5099355,4.1069093 11.269748,7.34709677 7.27277419,7.34709677 C3.27580038,7.34709677 0.0356129032,4.1069093 0.0356129032,0.109935484 L14.5099355,0.109935484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.8944516 17.5850323 16.8944516 0.109935484 31.3703226 0.109935484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6645161,21.7858065 C25.4899725,21.7763247 25.3378234,21.9034538 25.316129,22.0769032 L25.9896774,22.0769032 C25.9796938,21.9070061 25.8344785,21.7770039 25.6645161,21.7858065 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1316129,16.6188387 C20.1343886,16.6196937 16.8944516,19.860324 16.8944516,23.8575484 L31.3687744,23.8575484 C31.3691849,21.9378656 30.6068818,20.0966675 29.2496062,18.7391016 C27.8923307,17.3815357 26.0512957,16.6188387 24.1316129,16.6188387 Z",
    id: "Path"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZendeskMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zendesk-mark.a6950d77.svg";
export { ForwardRef as ReactComponent };